import { runDemo } from "../shared/demoRunner";
import { createLightsScene } from "./scene";

runDemo({
    createScene: createLightsScene,
});
